module.exports = __webpack_public_path__ + "static/media/credit-card.21ab03a3.svg";